import { Map as map } from 'immutable';
const C = require("../constants");

function ExpenseDetailReducer(state = map(), action) {
    switch (action.type) {
        case C.EXPENSES_DETAIL_LIST:
            return action.expenses_detail;
        case C.EXPENSES_DETAIL_DELETE:
            return state.filter(expense_detail => {
                return expense_detail.id !== action.expense_detail
            });
        case C.EXPENSES_DETAIL_ADD:
            return state.concat(action.expense_detail);
        default:
            return state;
    }
}

export default ExpenseDetailReducer;


// WEBPACK FOOTER //
// ./src/reducers/ExpenseDetailReducer.js